import { Actions, ButtonLink, IconDownload } from 'braid-design-system';

import figma from './ad-sync-posting-ui.fig';
import pdf from './ad-sync-posting-ui.pdf';

export const UxFiles = () => (
  <Actions>
    <ButtonLink
      download="ad-sync-posting-ui.fig"
      href={figma}
      icon={<IconDownload />}
      variant="soft"
    >
      Figma file
    </ButtonLink>

    <ButtonLink
      download="ad-sync-posting-ui.pdf"
      href={pdf}
      icon={<IconDownload />}
      variant="soft"
    >
      PDF file
    </ButtonLink>
  </Actions>
);
